var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticStyle:{"position":"unset !important"},attrs:{"show":true,"rounded":"sm","opacity":"0.5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }